module.exports = __webpack_public_path__ + "static/media/dpi.6b3ba3e7.png";